// extracted by mini-css-extract-plugin
export default {"color":"Proj3_color__aORoK","middleTric":"Proj3_middleTric__1e5U5","bgCard":"Proj3_bgCard__MwLcG","linkPro":"Proj3_linkPro__E9J7f","imgSizeProj":"Proj3_imgSizeProj__tMqbN"};